import Instance from "../../../../Axios";

// New Actions for the app

const GetCredIntervencao = (intId) => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/intervencoes/intervencao/${intId}`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_INTERVENCAO",
        payload: data.yData[0],
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredIntervencao;
